import styled, { css } from "styled-components"

import Icon from "~/components/atoms/Icon"
import ActionPairButton from "~/components/molecules/ActionPairButton"
import { RecruitmentType } from "~/consts"
import { Color, LineHeight, RadiusSize, Shadow, SpacingSize, TextSize } from "~/consts/style-mixins"

interface Props {
  open: boolean
  recruitmentType: keyof typeof RecruitmentType
  mainAction: {
    label: string
    action: Function
  }
  subAction: {
    label: string
    action: Function
  }
}

interface StyledProps {
  open: boolean
}

const ApplyCompleteModal = ({ open, recruitmentType, mainAction, subAction }: Props) => {
  const _generateClassName = (recruitmentType: keyof typeof RecruitmentType): string => {
    switch (recruitmentType) {
      case "newGradJob":
        return "gtm_complete-new-grad-job-application"
      case "shortInternship":
        return "gtm_complete-shortinternship-application"
      case "event":
        return "gtm_complete-event-application"
      default:
        return ""
    }
  }

  return (
    <>
      <StyledDialogWrapper open={open} className={_generateClassName(recruitmentType)}>
        <StyledDialogHeading>エントリーが完了しました！</StyledDialogHeading>
        <StyledDialogContent>
          <StyledDescription>担当者からのメッセージをお待ちください。</StyledDescription>
          <StyledIcon type="Success" size={64} color={Color.Secondary} />
        </StyledDialogContent>
        <StyledActionPairButtonWrapper>
          <ActionPairButton
            mainAction={{
              label: mainAction.label,
              action: mainAction.action,
            }}
            subAction={{
              label: subAction.label,
              action: subAction.action,
            }}
            vertical={true}
          />
        </StyledActionPairButtonWrapper>
      </StyledDialogWrapper>
      <StyledDialogOverlay open={open} />
    </>
  )
}

const StyledDialogWrapper = styled.div`
  width: 80%;
  max-width: 400px;
  margin: auto;
  padding: 24px;
  display: none;
  position: fixed;
  top: 30vh;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  ${Shadow.Deep};
  ${({ open }: StyledProps) => css`
    ${open &&
    css`
      display: block;
    `}
  `}
`

const StyledDialogOverlay = styled.div`
  position: fixed;
  z-index: 99;
  top: -25%;
  left: 0;
  bottom: 0;
  right: 0;
  height: 125%;
  width: 100%;
  background: #000;
  display: none;
  opacity: 0.5;
  ${({ open }: StyledProps) => css`
    ${open &&
    css`
      display: block;
    `}
  `}
`

const StyledDialogHeading = styled.div`
  margin-bottom: 4px;
  font-size: ${TextSize.L}px;
  font-weight: bold;
  line-height: ${LineHeight.S}%;
`

const StyledDialogContent = styled.div`
  margin-bottom: ${SpacingSize.M}px;
  font-size: ${TextSize.S}px;
  line-height: ${LineHeight.M}%;
`

const StyledDescription = styled.div`
  margin-bottom: ${SpacingSize.XL}px;
  font-size: ${TextSize.S}px;
  line-height: ${LineHeight.M}%;
  color: ${Color.Gray};
`

const StyledIcon = styled(Icon)`
  margin: 24px auto;
  display: block;
`

const StyledActionPairButtonWrapper = styled.div`
  width: 100%;
  max-width: 280px;
  margin: auto;
`

export default ApplyCompleteModal
